import { connect } from 'react-redux';
import React, { Component } from 'react';
import routerActions from 'app/routerActions';
import ReactDOM from 'react-dom';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { api, apiUtils } from 'app/services';
import { reservationsActions, successState, apiCallFailure } from 'app/actions';
import * as selectors from 'app/selectors';
import {
KBLoadingContainer,
KBButton,
KBDropdown,
KBPopover,
KBTipsy,
KBStatisticNumber } from
'components';
import { KBPopoverConfirm } from 'components/tools';
import {
MEETING_COLORS,
AREATYPES_CLASS,
RESERVATION_PROGRESS_STATUS,
RESERVATION_PROGRESS_CLASS } from
'app/constants';
import {
getInitialDate,
MEETING_TIME_COUNT,
MEETING_DEFAULT_COUNT,
MEETING_START_TIME,
MEETING_END_TIME,
MEETING_DEFAULT_GRID_WIDTH } from
'utils/kbData';
import dayjs from 'utils/dayjs';
import MeetingBookingForm from './MeetingBookingForm';
import MeetingSearchRoomForm from './MeetingSearchRoomForm';
import MeetingPopup from './MeetingPopup';
import MeetingForm from './MeetingForm';
import MeetingRoomReportForm from './MeetingRoomReportForm';
import { KBDayPicker } from 'components/views';
import { canAccessLocation } from 'app/reducers/role';
import { percent, getEntitiesJsonArray } from 'utils/kbUtil';

const DISABLED_COLOR = 'rgb(230,230,230)';

var MeetingIndex = class extends React.Component {constructor(props) {super(props);this.state = this.getInitialState();this.cancelBooking = this.cancelBooking.bind(this);this.getMeetingInitData = this.getMeetingInitData.bind(this);this._loadData = this._loadData.bind(this);this.cancelMeeting = this.cancelMeeting.bind(this);this.overMeeting = this.overMeeting.bind(this);this.chooseMeetingMode = this.chooseMeetingMode.bind(this);this.renderDateTime = this.renderDateTime.bind(this);this.devicesJsx = this.devicesJsx.bind(this);this.parseMinutes = this.parseMinutes.bind(this);this.getRows = this.getRows.bind(this);this.addMeetingBooking = this.addMeetingBooking.bind(this);this.getRowsEveryone = this.getRowsEveryone.bind(this);this.rowsJsx = this.rowsJsx.bind(this);this.progressDisabledJsx = this.progressDisabledJsx.bind(this);this.parseReservations = this.parseReservations.bind(this);this.hideOtherDropDown = this.hideOtherDropDown.bind(this);this.showCurrentDropDown = this.showCurrentDropDown.bind(this);this.progressJsx = this.progressJsx.bind(this);this.meetingRoomsJsx = this.meetingRoomsJsx.bind(this);this.meetingRoomsTitleJsx = this.meetingRoomsTitleJsx.bind(this);this.fullZero = this.fullZero.bind(this);this.meetingRoomsTimeJsx = this.meetingRoomsTimeJsx.bind(this);this.changeDayPicker = this.changeDayPicker.bind(this);this.searchMeetingRoom = this.searchMeetingRoom.bind(this);this.addMeeting = this.addMeeting.bind(this);this.initialScrollLeft = this.initialScrollLeft.bind(this);this.closePopup = this.closePopup.bind(this);this.reportMeetingRoom = this.reportMeetingRoom.bind(this);}getInitialState()


  {
    const { time, defaultDate } = this.props;
    return {
      loading: false,
      meetingInitDate: defaultDate,
      rows: this.getRows(this.getMeetingInitData(defaultDate)),
      searchTime: time,
      current_time: '',
      isInitialScroll: true,
      isShowMeetingPopup: false,
      current_reservation: {},
      meetingRoomsWithReservations: [],
      totalInfo: {
        todayReservationsLength: 0,
        totalTime: 0,
        probability: 0 } };


  }componentDidMount()

  {
    const { appointment, time } = this.props;
    let initialDate = getInitialDate(time);
    const { initStartDate, initEndDate } = initialDate;
    let start_at = initStartDate.format('YYYY-MM-DD HH:mm:ss');
    let end_at = initEndDate.format('YYYY-MM-DD HH:mm:ss');
    this._loadData({ start_at, end_at });

    this.mounted = true;

    if (appointment) {
      setTimeout(() => {
        this.searchMeetingRoom();
      }, 200);
    }

    this.initialScrollLeft();
  }componentWillUnmount()

  {
    this.mounted = false;
  }cancelBooking(

  reservation) {
    const { deleteReservationsAction } = this.props;
    let id = reservation.id;
    let tip = '确定要取消该次会议?';
    if (reservation.has_discount_goods) {
      tip = '此订单包含加购项，取消仅退会议室预定费用，操作前请与客户确认已经知晓退款内容，请确认是否取消该次会议？';
    }
    KBPopoverConfirm({
      name: '取消会议',
      context: tip,
      callback: () => {
        return api.deleteReservations(id).then(
        json => {
          deleteReservationsAction.success(json, { id, key: 'reservations' });
          KBPopover.close();
          this.setState({ isShowMeetingPopup: false });
          this._loadData();
        },
        errors => {
          deleteReservationsAction.failure(errors);
          KBPopover.close();
        });

      } });

  }getMeetingInitData(




  defaultDate) {
    let currentDayjs = dayjs();
    let initialDate = defaultDate;
    // 当前时间距离9点半 minutes
    let minutes = currentDayjs.diff(initialDate.initStartDate, 'minutes');
    if (minutes < 0) {
      minutes = 0;
    }
    return {
      minutes };

  }componentDidUpdate(prevProps) {
    const { isInitialScroll } = this.state;
    if (
    dayjs(this.props.time).format('YYYY-MM-DD') !=
    dayjs(prevProps.time).format('YYYY-MM-DD'))
    {
      let initialDate = getInitialDate(this.props.time);
      const { initStartDate, initEndDate } = initialDate;
      let start_at = initStartDate.format('YYYY-MM-DD HH:mm:ss');
      let end_at = initEndDate.format('YYYY-MM-DD HH:mm:ss');
      this.setState({
        searchTime: this.props.time,
        loading: true,
        meetingInitDate: initialDate,
        rows: this.getRows(this.getMeetingInitData(initialDate)) });

      this._loadData({
        start_at,
        end_at });

    }
    if (this.meetingScroll && isInitialScroll) {
      this.initialScrollLeft();
    }
  }_loadData(

  params) {
    const { getReservationsAction, loc_id } = this.props;
    // 获取会议室信息和预定信息
    const startDate = dayjs(params && params.start_at || this.state.searchTime).format('YYYY-MM-DD');
    api.getMeetingRoomsAndReservations({
      location_id: loc_id,
      // ...params,
      start_date: startDate
      // end_at: params.end_at ? params.end_at.split(' ')[0] : undefined,
      // state: 'reserved_active'
    }).
    then(json => {
      const data = json.json || [];

      // 遍历修改数据-计算统计数据
      let todayReservationsLength = 0;
      let totalTime = 0;
      const companyColors = [];
      data.forEach(meeting => {
        meeting.reservations.forEach(reservation => {
          // 统计今天预定数量
          if (
          dayjs.unix(reservation.start_at).format('YYYY-MM-DD') === dayjs(startDate).format('YYYY-MM-DD'))
          {
            todayReservationsLength++;
          }

          // 添加颜色-每个公司颜色需要一样
          if (reservation.organization_name) {
            if (!companyColors.includes(reservation.organization_name)) {
              reservation.color = MEETING_COLORS[companyColors.length];
              companyColors.push(reservation.organization_name);
            } else {
              reservation.color = MEETING_COLORS[companyColors.indexOf(reservation.organization_name)];
            }
          }

          // 统计时间
          totalTime += dayjs.unix(reservation.end_at).diff(dayjs.unix(reservation.start_at), 'hours', true);

          // 转换时间格式
          reservation.start_at = dayjs.unix(reservation.start_at).toDate();
          reservation.end_at = dayjs.unix(reservation.end_at).toDate();
        });
      });
      totalTime = parseFloat(totalTime).toFixed(2);
      const probability = percent(MEETING_TIME_COUNT * data.length, totalTime);


      this.setState({
        meetingRoomsWithReservations: data,
        totalInfo: {
          todayReservationsLength,
          totalTime,
          probability } });


    }).
    catch(errors => {
      getReservationsAction.failure(errors);
    }).
    finally(() => {
      this.setState({
        loading: false,
        isShowMeetingPopup: false });

    });
  }cancelMeeting(

  reservation) {
    const { apiCallFailureActions } = this.props;
    let id = reservation.id;

    KBPopoverConfirm({
      name: '结束会议室预定',
      context: `是否结束当前${reservation.area_name || '会议室'}预定?`,
      callback: () => {
        if (dayjs(reservation.start_at).diff(new Date(), 'hours', true) >= 0) {
          KBPopover.close();
          apiCallFailureActions({
            status: 'error',
            message: '会议还没开始，不能终止!' });

          return;
        }
        //getOverTimeInfo
        return api.getOverTimeInfo(id).then(({ json }) => {
          KBPopover.close();
          this.setState({ isShowMeetingPopup: false });
          let terminate_at = json.terminate_at;
          let total_amount = json.total_amount;
          let end_at = reservation.end_at;
          if (!dayjs(end_at).isSame(terminate_at, 'day')) {
            terminate_at = dayjs(end_at).
            clone().
            set({ hour: 19, minute: 0, second: 0 });
          }

          if (total_amount > 0) {
            this.chooseMeetingMode(
            reservation,
            true,
            terminate_at,
            total_amount);

            return;
          }

          this.overMeeting(reservation, false, terminate_at);
        });
      } });

  }overMeeting(

  reservation, isMakeInvoice = false, terminate_at) {
    const { successAction, updateReservationsActions } = this.props;
    if (!terminate_at) {
      return;
    }

    let id = reservation.id;
    api.
    putTerminate(id, {
      make_invoice: isMakeInvoice,
      terminate_at }).

    then(
    json => {
      updateReservationsActions.success(json);
      successAction({
        message: `成功结束当前会议室预定${
        isMakeInvoice ? '并生成账单' : ''
        }!` });

    },
    error => {
      updateReservationsActions.failure(error);
    }).

    finally(() => {
      KBPopover.close();
    });
  }chooseMeetingMode(


  reservation,
  isMakeInvoice = false,
  terminate_at,
  total_amount)
  {
    KBPopover.show(
    <div>
        <header className="kb-form-header">
          <h2 className="header-title">生成账单</h2>
          <i
        className="iconfont header-close icon-cancel"
        onClick={KBPopover.close} />

        </header>
        <div className="kb-form-container">
          <div className="kb-row">
            {`当前预定会议室超时将生成金额为${total_amount}(RMB)的账单，是否生成此账单？`}
          </div>
          <div className="kb-row">
            <div className="kb-form-fr">
              <KBButton
            className="certain-btn"
            onClick={this.overMeeting.bind(
            null,
            reservation,
            isMakeInvoice,
            terminate_at)}>


                立即生成账单
              </KBButton>
              <KBButton
            className="certain-btn"
            onClick={this.overMeeting.bind(
            null,
            reservation,
            false,
            terminate_at)}>


                取消生成账单
              </KBButton>
            </div>
          </div>
        </div>
      </div>);

  }renderDateTime()

  {
    const { time, reservation_time_range } = this.props;
    let current_date = dayjs().format('YYYY-MM-DD');
    let select_date = dayjs(time).format('YYYY-MM-DD');

    var current_time_left;
    var current_time = dayjs().minute();
    var remainder = current_time - 30;
    if (remainder > 0) {
      current_time = current_time - 30;
      remainder = 1;
    } else {
      remainder = 0;
    }
    var hour_count = (dayjs().hour() - reservation_time_range.begin) * 2;
    current_time_left =
    Math.ceil(current_time / 30 * 33) + remainder * 33 + hour_count * 33;

    return (
      <div className="timeline-box">
        {select_date == current_date ?
        <div
        className="current-time"
        style={{ left: current_time_left }}>
        </div> :

        ''}

        {this.meetingRoomsTimeJsx()}
        {this.meetingRoomsJsx()}
      </div>);

  }devicesJsx(

  devices) {
    if (!devices.length) {
      return <div className="meet-device"></div>;
    }

    let whiteboard = devices.find(device => device && device.id == 1);
    let tv = devices.find(device => device && device.id == 2);
    let camera = devices.find(device => device && device.id == 3);
    return (
      <div className="meet-device">
        {tv ? <i className="iconfont icon-tv" /> : ''}
        {whiteboard ? <i className="iconfont icon-Whiteboard" /> : ''}
        {camera ? <i className="iconfont icon-camera" /> : ''}
        <i />
      </div>);

  }parseMinutes(

  minutes) {
    // 有多少个不可选择项
    let d = Math.floor(minutes / 30);
    // 取余数
    let c = minutes % 30;

    return {
      d,
      c };

  }getRows(

  meetingInitDate) {
    // progress progressDisabled full empty disabled
    const {
      reservation_time_range: { begin, end },
      setting_reservation_time } =
    this.props;
    var defaultGrid = {
      state: 'empty',
      width: 0 };

    var rows = [];
    let minutes = meetingInitDate.minutes;

    const { d, c } = this.parseMinutes(minutes);
    for (let i = begin * 2; i < end * 2; i++) {
      var grid = Object.assign({}, defaultGrid);
      if (
      i / 2 < setting_reservation_time.begin ||
      i / 2 >= setting_reservation_time.end)
      {
        grid.state = 'none';
      } else {
        if (i < d) {
          grid.state = 'disabled';
        }
        if (c > 0 && d + 1 == i) {
          grid.state = 'progressDisabled';
          grid.width = Math.ceil(c / 30 * 33);
        }
      }
      grid.id = i;
      rows.push(grid);
    }

    return rows;
  }addMeetingBooking(

  meeting, start_at) {
    const {
      defaultDate,
      isManager,
      reservation_time_range,
      setting_reservation_time } =
    this.props;
    const { loc_id } = this.props;
    let end_at = dayjs(start_at).
    clone().
    add(1, 'hours');
    let END_AT = dayjs(start_at).set({
      hour: reservation_time_range.end,
      minute: 0,
      second: 0 });

    if (end_at.diff(END_AT, 'minutes') > 0) {
      end_at = dayjs(END_AT).clone();
    }
    if (this.mounted) {
      this.setState({
        rows: this.getRows(this.getMeetingInitData(defaultDate)) });

    }

    isManager &&
    KBPopover.show(
    <MeetingBookingForm
    end_at={end_at}
    start_at={start_at}
    reservation_time_range={setting_reservation_time}
    initialValues={{
      end_at,
      start_at }}

    meeting={meeting}
    loc_id={loc_id}
    callback={this._loadData} />);


  }getRowsEveryone(

  meetingInitDate, meeting) {
    const { reservation_time_range = [] } = meeting;
    let defaultGrid = {
      state: 'empty',
      width: 0 };

    let minutes = meetingInitDate.minutes;
    const { d, c } = this.parseMinutes(minutes);
    const currentDay = dayjs(this.state.searchTime).day() ? dayjs(this.state.searchTime).day() : 7;
    let currentReservation = reservation_time_range[0];
    if (reservation_time_range.length > 1)
    currentReservation = reservation_time_range.filter(
    item => item.day == currentDay)[
    0];
    const { begin, end } = currentReservation;

    let row = [];

    for (let i = 0; i < 48; i++) {
      let grid = Object.assign({}, defaultGrid);
      if (i * 30 < begin || i * 30 >= end) {
        grid.state = 'none';
      } else {
        if (i < d) {
          grid.state = 'disabled';
        }
        if (c > 0 && d + 1 == i) {
          grid.state = 'progressDisabled';
          grid.width = Math.ceil(c / 30 * 33);
        }
      }
      if (currentReservation.nowork) {
        grid.state = 'none';
      }
      grid.id = i;
      row.push(grid);
    }
    return row;
  }rowsJsx(

  meeting) {
    // let { rows } = this.state
    const { defaultDate } = this.props;
    const rows = this.getRowsEveryone(this.getMeetingInitData(defaultDate), meeting);
    let jsx = rows.map((grid, index) => {
      let start_at = defaultDate.initStartDate.
      clone().
      add(grid.id * 30, 'minutes');
      if (grid.state == 'none') {
        return (
          <div key={index} className="time-grid meeting-block_disabled"></div>);

      }

      if (grid.state == 'disabled') {
        return <div key={index} className="time-grid past-tense"></div>;
      }

      if (grid.state == 'progressDisabled') {
        return (
          <div
          key={index}
          className="time-grid"
          onClick={() => {
            this.addMeetingBooking(meeting, start_at);
          }}>
          </div>);

      }

      return (
        <div
        key={index}
        className="time-grid"
        onClick={() => {
          this.addMeetingBooking(meeting, start_at);
        }}>
        </div>);

    });
    return jsx;
  }progressDisabledJsx()

  {
    let rows = Object.assign([], this.state.rows);

    let jsx = rows.map((grid, index) => {
      if (grid.state == 'progressDisabled') {
        let left = 33 * (index - 1);
        let width = grid.width;
        return (
          <div
          key={index}
          className="meeting-status"
          style={{ left, width, backgroundColor: DISABLED_COLOR, opacity: 1 }}>
          </div>);

      }

      return null;
    });

    return jsx;
  }parseReservations(

  reservations) {
    const {
      defaultDate,
      reservation_time_range: { begin } } =
    this.props;

    reservations = reservations.map((reservation, index) => {
      let startDayjs = defaultDate.initStartDate;
      let startReservation = dayjs(reservation.start_at);
      let endReservation = dayjs(reservation.end_at);
      let minutes = startReservation.diff(startDayjs, 'minutes');
      let minutesEnd = endReservation.diff(startReservation, 'minutes');
      const { d, c } = this.parseMinutes(minutes);
      const minutesDate = this.parseMinutes(minutesEnd);

      reservation.left = 33 * (d - begin * 2) + Math.ceil(c / 30 * 33);
      reservation.width =
      minutesDate.d * 33 + Math.ceil(minutesDate.c / 30 * 33);
      return reservation;
    });
    return reservations;
  }hideOtherDropDown(

  currentIndex, id) {
    const { meetingRoomsWithReservations } = this.state;

    meetingRoomsWithReservations.forEach(meeting => {
      meeting.reservations.forEach((reservation, index) => {
        if (reservation && reservation.id == id && index == currentIndex) {
          return;
        }

        const dropDown = this['KBRoomDropDwon' + reservation.id + index];
        dropDown && dropDown.hide();
      });
    });
  }showCurrentDropDown(

  index, meetingIndex, reservation) {
    let meetingStatusClientLeft = this[
    'meetingStatus' + reservation.id + index].
    getBoundingClientRect().left;
    let containerClientLeft = this.container.getBoundingClientRect().
    left;
    let distanceLeft = meetingStatusClientLeft - containerClientLeft - 30;
    api.getReservationDetails(reservation.id).then(res => {
      const data = res.json;
      let current_reservation = Object.assign(
      {},
      {
        // reservation包含已处理过的数据，覆盖详情接口的数据
        ...data,
        ...reservation },

      { distanceLeft: distanceLeft },
      { meetingIndex: meetingIndex + 1 });

      this.setState({
        current_reservation,
        isShowMeetingPopup: true });

    });
  }progressJsx(

  meeting, meetingIndex) {
    let reservations = this.parseReservations(
    Object.assign([], meeting.reservations));


    let jsx = reservations.map((reservation, index) => {
      const { left, width } = reservation;
      return (
        <div
        key={index}
        className="meeting-status"
        ref={ref => this[`meetingStatus${reservation.id}${index}`] = ref}
        style={{ width, left, backgroundColor: reservation.color, zIndex: 9 }}
        onClick={() => {
          this.showCurrentDropDown(index, meetingIndex, reservation);
        }}>
        </div>);

    });

    return jsx;
  }meetingRoomsJsx()


  {
    const { meetingRoomsWithReservations } = this.state;
    const meetingList = meetingRoomsWithReservations;
    const render =
    meetingList &&
    meetingList.map((meeting, index) => {
      return (
        <div className="line-box" key={index}>
            {this.rowsJsx(meeting)}
            {this.progressJsx(meeting, index)}
            {this.progressDisabledJsx(meeting)}
          </div>);

    });

    return render;
  }meetingRoomsTitleJsx()


  {
    const { loc_id } = this.props;
    const meetingList = this.state.meetingRoomsWithReservations;
    const render =
    meetingList &&
    meetingList.map((meeting, index) => {
      return (
        <div className="line-meet" key={index}>
            <div className="meet-title">
              <KBTipsy content={meeting.name}>
                <Link
              to={`/admin/locations/${loc_id}/meeting/info/${meeting &&
              meeting.id}`}>

                  <i
                className={`iconfont ${AREATYPES_CLASS[meeting.area_type]}`}
                style={{ marginRight: 5 }} />

                  {meeting.name}
                </Link>
              </KBTipsy>
            </div>
          </div>);

    });

    return render;
  }fullZero(

  number) {
    if (number <= 9) {
      return '0' + number;
    }
    return number;
  }meetingRoomsTimeJsx()


  {
    const {
      reservation_time_range: { begin, end } } =
    this.props;
    let times = [];
    for (let i = begin; i <= end; i++) {
      let st = this.fullZero(i);
      times.push({
        id: i,
        name: st });

    }

    return (
      <div style={{ height: 30 }}>
        <div className="line-time">
          {times.map((json, index) => {
            return (
              <div key={index} className="time-quantum">
                {json.name}
              </div>);

          })}
        </div>
      </div>);

  }changeDayPicker(

    date) {
    const { routerActions, loc_id } = this.props;
    this.filterDate && this.filterDate.hide();
    if (this.mounted) {
      this.setState({
        searchTime: date });

    }

    routerActions.replace(
    `/admin/locations/${loc_id}/meeting?time=${dayjs(date).format(
    'YYYY-MM-DD')
    }`);

  }searchMeetingRoom()

  {
    const { loc_id, time } = this.props;

    KBPopover.show(<MeetingSearchRoomForm time={time} loc_id={loc_id} />);
  }addMeeting()

  {
    const { loc_id } = this.props;
    KBPopover.show(<MeetingForm loc_id={loc_id} />);
  }initialScrollLeft()

  {
    if (!this['meetingScroll']) {
      return;
    }

    if (dayjs().get('hour') < 10) {
      this['meetingScroll'].scrollLeft = 0;
    } else {
      this['meetingScroll'].scrollLeft = 640;
    }
    this.setState({
      isInitialScroll: false });

  }closePopup()

  {
    this.setState({
      isShowMeetingPopup: false });

  }reportMeetingRoom()

  {
    const { loc_id } = this.props;
    let initValue = {
      startYMD: new Date(),
      endYMD: new Date(),
      startHM: '9,1',
      endHM: '9,1',
      start_time: dayjs(new Date()).
      clone().
      set({ hour: 9, minute: 0, second: 0 }),
      end_time: dayjs(new Date()).
      clone().
      set({ hour: 9, minute: 0, second: 0 }) };

    KBPopover.show(
    <MeetingRoomReportForm loc_id={loc_id} initialValues={initValue} />);

  }render()

  {
    const {
      loadingStatus,
      isManager,
      defaultDate,
      setting_reservation_time } =
    this.props;
    const {
      searchTime,
      loading,
      current_reservation,
      isShowMeetingPopup,
      meetingRoomsWithReservations,
      totalInfo } =
    this.state;
    const meetings = meetingRoomsWithReservations;
    const today = dayjs().toDate();
    const tomorrow = dayjs().
    add(1, 'days').
    toDate();
    const yesterday = dayjs().
    subtract(1, 'days').
    toDate();
    if (loadingStatus == 'loading') {
      return (
        <section className="nav-section-container  f-right">
          <KBLoadingContainer loading={true} />
        </section>);

    }

    return (
      <section
      className="nav-section-container  f-right"
      ref={ref => {
        this.container = ref;
      }}
      style={{ position: 'relative' }}>

        <header className="nav-header clear-fix">
          <h2 className="nav-section-header-title f-left">
            <span>预约管理</span>
          </h2>
          {isManager ?
          <div className="f-right" style={{ display: 'flex' }}>
              <a className="c-btn-secondary" onClick={this.reportMeetingRoom}>
                导出会议室记录
              </a>
              <a className="bordered-btn" onClick={this.searchMeetingRoom}>
                <i className="iconfont icon-add" />
                添加新预约
              </a>
            </div> :

          ''}

        </header>
        {meetings && meetings.length > 0 ?
        <div className="nav-section-content-container">
            <div className="m-updown t-center">
              <div className="chart-box t-left" style={{ marginRight: '75px' }}>
                <KBStatisticNumber
              number={totalInfo.todayReservationsLength}
              unit="个"
              name="会议个数" />

              </div>
              <div className="chart-box t-left" style={{ marginRight: '75px' }}>
                <KBStatisticNumber
              number={totalInfo.totalTime}
              unit="小时"
              name="总时长" />

              </div>
              <div className="chart-box t-left">
                <KBStatisticNumber
              number={`${totalInfo.probability}%`}
              name="利用率" />

              </div>
            </div>
            <div className="m-top" style={{ marginBottom: 40 }}>
              <div className="kb-title m-bottom">
                <span>场地管理</span>
              </div>
              <KBDropdown
              ref={ref => {
                this.filterDate = ref;
              }}>
                <KBDropdown.KBDropdownTrigger>
                  <div className="task-status-title">
                    <i
                  className="iconfont icon-calendar"
                  style={{ marginRight: '3px' }} />

                    <span>
                      选择日期:{dayjs(searchTime).format('YYYY-MM-DD')}
                    </span>
                    <span className="task-deg" />
                  </div>
                </KBDropdown.KBDropdownTrigger>
                <KBDropdown.KBDropdownContent className="kb-range-date-content">
                  <KBDayPicker
                onChange={this.changeDayPicker}
                selectedDay={searchTime} />

                </KBDropdown.KBDropdownContent>
              </KBDropdown>
              <div className="time-filter">
                <button
              className={
              dayjs(searchTime).isSame(yesterday, 'day') ? 'active' : ''}

              onClick={this.changeDayPicker.bind(null, yesterday)}>

                  昨天
                </button>
                <button
              className={
              dayjs(searchTime).isSame(today, 'day') ? 'active' : ''}

              onClick={this.changeDayPicker.bind(null, today)}>

                  今天
                </button>
                <button
              className={
              dayjs(searchTime).isSame(tomorrow, 'day') ? 'active' : ''}

              onClick={this.changeDayPicker.bind(null, tomorrow)}>

                  明天
                </button>
              </div>
            </div>
            <KBLoadingContainer loading={loading}>
              {Object.values(current_reservation).length > 0 ?
            <MeetingPopup
            reservation={current_reservation}
            defaultDate={defaultDate}
            closePopup={this.closePopup}
            isShowMeetingPopup={isShowMeetingPopup}
            isManager={isManager}
            reservation_time_range={setting_reservation_time}
            cancelBooking={this.cancelBooking}
            cancelMeeting={this.cancelMeeting} /> :


            ''}

              <div
            ref={ref => {
              this.meetingScroll = ref;
            }}
            style={{
              overflowX: 'auto',
              overflowY: 'hidden',
              marginTop: 15,
              marginLeft: 140 }}>


                <div className="meeting-title-box">
                  {this.meetingRoomsTitleJsx()}
                </div>
                {this.renderDateTime()}
              </div>
            </KBLoadingContainer>
          </div> :

        <div className="meeting-empty">
            <div className="meeting-empty-state">
              <p className="meeting-empty-title">暂无会议室</p>
              <p className="meeting-empty-text">请先添加场地后再创建会议室预约</p>
              {isManager ?
            <button type="button" className="bordered-btn" onClick={this.addMeeting}>
                  <i className="iconfont icon-add" />
                  添加场地
                </button> :
            null}
            </div>
          </div>}

      </section>);

  }};


function mapStateToProps(state, props) {
  const { params, location } = props;
  const { user } = state;
  let loc_id = params.id;
  let locationSetting = selectors.getLocationSetting(state, loc_id);
  const reservationTimeRange =
  locationSetting &&
  locationSetting.meeting_room_settings &&
  locationSetting.meeting_room_settings.reservation_time_range;
  let reservation_time_range = { begin: 0, end: 24 };
  let settingDateRange =
  reservationTimeRange && reservationTimeRange.find(r => r.day === -1);
  let setting_reservation_time = settingDateRange ?
  { begin: settingDateRange.begin / 60, end: settingDateRange.end / 60 + 1 } :
  { begin: 0, end: 24 };

  const time = location.query ?
  dayjs(location.query.time).toDate() :
  new Date();
  const defaultDate = getInitialDate(time);
  const loadingStatus = selectors.getLoadingStatusOfKey(state, 'meetingRooms');
  let isManager = canAccessLocation(user, loc_id);

  const appointment = location.query.appointment == 'new' ? true : false;
  return {
    loc_id,
    loadingStatus,
    time,
    defaultDate,
    appointment,
    isManager,
    reservation_time_range,
    setting_reservation_time };

}

function mapDispatchToProps(dispatch) {
  return {
    successAction: bindActionCreators(successState, dispatch),
    routerActions: bindActionCreators(routerActions, dispatch),
    getReservationsAction: bindActionCreators(
    reservationsActions.all,
    dispatch),

    updateReservationsActions: bindActionCreators(
    reservationsActions.update,
    dispatch),

    deleteReservationsAction: bindActionCreators(
    reservationsActions.delete,
    dispatch),

    apiCallFailureActions: bindActionCreators(apiCallFailure, dispatch) };

}

export default connect(mapStateToProps, mapDispatchToProps)(MeetingIndex);
